import axios, { AxiosResponse } from 'axios';

const { CancelToken } = axios;

export enum VariableType {
    SOURCE,
    TENANT,
    LOCATION,
    USER,
    TICKET,
    NOTE,
    REVIEW,
    REQUEST_REVIEW,
    SOCIAL, // --> SOCIAL_LIVESTREAM
    SOCIAL_POST_FAILED, // --> SOCIAL_CALENDAR
    SOCIAL_POST_LISTENING, // --> SOCIAL_LISTENING
    NOTIFICATION,
    SURVEY,
    SOCIAL_LIVESTREAM,
    SOCIAL_CALENDAR,
    SOCIAL_LISTENING,
    SOCIAL_SCHEDULED_POST,
    DATE,
    REQUEST_TEMPLATE,
    REQUEST,
    COMMENT2,
    CREDENTIAL,
    TENANT_PREFERENCE,
    REVIEW_RESPONSE,
    MATCHER_RESULT_CREDENTIAL_MATCHING,
    ACTION_PLAN,
    REVIEW_HOLISTIC,
    REVIEW_RESPONSE_HOLISTIC,
}

export interface VariableTypeAndObjectID {
    variableType: VariableType;
    objectID?: string;
}

export interface VariableTypeAndObjectIDs {
    variableTypeAndObjectIDs: VariableTypeAndObjectID[];
    basic?: boolean;
}

export interface Variable {
    variableName: string;
    variableType: number;
}

export interface VariableExtractRequest {
    text: string;
    variableTypes?: any[];
}

const variableBaseUrl = (tenantId: number): string => {
    return `/api/tenants/${tenantId}/variable`;
};

export let cancelGetVariableNames: any; // eslint-disable-line import/no-mutable-exports
export let cancelExtractVariables: any; // eslint-disable-line import/no-mutable-exports

export const getVariableNames = async (
    tenantId: number,
    variableTypeAndObjectIDs: VariableTypeAndObjectID[] = [],
    basic = false,
): Promise<Variable[]> => {
    const params: any = {
        tenantId,
        variableTypeAndObjectIDs: { variableTypeAndObjectIDs, basic },
    };

    const response: AxiosResponse = await axios.post(`${variableBaseUrl(tenantId)}`, params, {
        cancelToken: new CancelToken((cancel) => {
            cancelGetVariableNames = cancel;
        }),
    });

    return response.data;
};

export const extractVariables = async (
    tenantId: number,
    variableRequest: VariableExtractRequest,
): Promise<Variable[]> => {
    const params: any = {
        tenantId,
        variableRequest,
    };

    const response: AxiosResponse = await axios.post(`${variableBaseUrl(tenantId)}/extract`, params, {
        cancelToken: new CancelToken((cancel) => {
            cancelExtractVariables = cancel;
        }),
    });

    return response.data;
};
